import React from "react";
import SectionIcon from "./SectionIcon";

const SelectionStep = ({ copy, pillars, sections, selected, availableSectionIds, onToggle, onContinue }) => (
  <section className="estate-mapping__content">
    <h2>{copy.selection.title}</h2>
    <p>{copy.selection.body}</p>
    {pillars.map((pillar) => {
      const visibleSectionIds = pillar.ids.filter((id) => availableSectionIds.includes(id));
      if (visibleSectionIds.length === 0) return null;

      return (
      <div key={pillar.label}>
        <div className="estate-mapping__pillar-label">{pillar.label}</div>
        <div className="estate-mapping__category-grid">
          {visibleSectionIds.map((id) => {
            const section = sections[id];
            const isSelected = selected.includes(id);
            return (
              <button key={id} className={`estate-mapping__category${isSelected ? " is-selected" : ""}`} onClick={() => onToggle(id)} type="button">
                <SectionIcon section={section} small />
                <span className="estate-mapping__category-title">{section.title}</span>
                <i />
              </button>
            );
          })}
        </div>
      </div>
      );
    })}
    <div className="estate-mapping__footer-actions">
      <span>{selected.length === 0 ? copy.selection.none : `${selected.length} ${selected.length === 1 ? copy.selection.singular : copy.selection.plural}`}</span>
      <button className="estate-mapping__button estate-mapping__button--primary" disabled={selected.length === 0} onClick={onContinue}>{copy.buttons.continue}</button>
    </div>
  </section>
);

export default SelectionStep;
